import { NestedDeal } from "@revelate/types";

export const getDealOwner = (deal: NestedDeal) => {
  const owner = deal?.users?.find((user) => user.role === "owner");
  return owner?.data || null;
};
